'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiVolume = function TiVolume(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.6 9.7c-0.8 0-1.5 0.3-2.3 0.8l-4.4 2.9c-1.3 0.9-3.7 1.6-5.2 1.6-2.8 0-5 2.2-5 5v3.3c0 2.8 2.2 5 5 5 1.5 0 3.9 0.8 5.1 1.6l4.5 3c0.8 0.5 1.5 0.7 2.3 0.7 1.5 0 3.1-1.1 3.1-3.6v-16.7c0-2.5-1.6-3.6-3.1-3.6z m-5.3 17.2c-1.8-1.1-4.6-1.9-6.6-1.9-1 0-1.7-0.7-1.7-1.7v-3.3c0-0.9 0.7-1.7 1.7-1.7 2 0 4.8-0.8 6.6-1.9v10.5z m5 3.1c0 0.1 0 0.1 0 0.2 0 0-0.1-0.1-0.2-0.1l-3.1-2.1v-12.7l3.2-2.1c0 0 0.1 0 0.1-0.1 0 0.1 0 0.2 0 0.2v16.7z' })
        )
    );
};

exports.default = TiVolume;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/volume.js
// module id = 4028
// module chunks = 0